import './Work.css';
import { useEffect, useState, useRef } from 'react';
import mixitup from 'mixitup';
import axios from 'axios';
import moment from 'moment';

function Work() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupDetails, setPopupDetails] = useState({
    imgSrc: '',
    title: '',
    detailsHTML: ''
  });
  const [cards, setCards] = useState([]);
  const [filters, setFilters] = useState([]);
  const cardRefs = useRef([]);
  const mixitupInstance = useRef(null);

  // Fetch data and initialize categories
  useEffect(() => {
    axios.get('/data/data.json')
      .then(response => {
        const sortedWorkData = response.data.work.sort((a, b) => {
          const dateA = moment(a.dateOfCreation, 'MMM YYYY').toDate();
          const dateB = moment(b.dateOfCreation, 'MMM YYYY').toDate();
          return dateB - dateA; // Sort in descending order (newest first)
        });
        setCards(sortedWorkData);

        // Extract unique categories for filters
        const uniqueCategories = [...new Set(sortedWorkData.map(card => card.category))];
        setFilters(uniqueCategories);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  // Initialize MixItUp instance after cards are loaded
  useEffect(() => {
    if (cards.length > 0) {
      if (mixitupInstance.current) {
        mixitupInstance.current.destroy(); // Clean up any existing instance
      }

      // Initialize MixItUp with a delay to ensure DOM is updated
      setTimeout(() => {
        mixitupInstance.current = mixitup('.work__container', {
          selectors: {
            target: '.work__card'
          },
          animation: {
            duration: 300
          }
        });
      }, 0);
    }
  }, [cards]);

  // Add event listeners to filter buttons
  useEffect(() => {
    const linkWork = document.querySelectorAll('.work__item');
    const activeWork = function() {
      linkWork.forEach(l => l.classList.remove('active-work'));
      this.classList.add('active-work');
    };

    linkWork.forEach(l => l.addEventListener('click', activeWork));

    // Cleanup event listeners when the component unmounts
    return () => {
      linkWork.forEach(l => l.removeEventListener('click', activeWork));
    };
  }, [filters]);

  const togglePortfolioPopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handlePortfolioClick = (index) => {
    const portfolioItem = cardRefs.current[index];
    if (!portfolioItem) return;

    const imgSrc = portfolioItem.querySelector('.work__img').src;
    const title = portfolioItem.querySelector('.work__title').innerHTML;
    const detailsHTML = portfolioItem.querySelector('.portfolio__item-details').innerHTML;

    setPopupDetails({
      imgSrc,
      title,
      detailsHTML
    });

    togglePortfolioPopup();
  };

  const setCardRef = (index, element) => {
    cardRefs.current[index] = element;
  };

  return (
    <div>
      <section className="work section" id="work">
        <h2 data-heading="My Portfolio" className="section__title">Recent Work</h2>

        <div className="work__filters">
          <span className="work__item active-work" data-filter="all">All</span>
          {filters.map((filter, index) => (
            <span key={index} className="work__item" data-filter={`.${filter}`}>
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </span>
          ))}
        </div>

        <div className="work__container container grid">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`work__card mix ${card.category}`}
              onClick={() => handlePortfolioClick(index)}
              ref={element => setCardRef(index, element)}
            >
              <img src={card.imgSrc} alt="" className="work__img" />
              <h3 className="work__title">{card.title}</h3>
              <span className="work__button">Demo <i className="uil uil-arrow-right work__button-icon"></i></span>
              <div className="portfolio__item-details">
              <h3 class='details__title'>{card.title}</h3>
              <p class='details__description'>{card.description}</p>
              <ul class='details__info'>
                {card.dateOfCreation && (
                  <li>Created - <span>{card.dateOfCreation}</span></li>
                )}

                {card.technologies && (
                  <li>Technologies - <span>{card.technologies}</span></li>
                )}
                <li>View - <span><a href={card.url}>{card.url}</a></span></li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Portfolio Popup */}
      {isPopupOpen && (
        <div className="portfolio__popup open">
          <div className="portfolio__popup-inner">
            <div className="portfolio__popup-content grid">
              <span className="portfolio__popup-close" onClick={togglePortfolioPopup}><i className="uil uil-times"></i></span>
              <div className="pp__thumbnail">
                <img src={popupDetails.imgSrc} alt="" className="portfolio__popup-img" />
              </div>
              <div className="portfolio__popup-info">
                <div className="portfolio__popup-subtitle">Featured - <span>{popupDetails.title}</span></div>
                <div className="portfolio__popup-body" dangerouslySetInnerHTML={{ __html: popupDetails.detailsHTML }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Work;
